export const STICKY_ALERT_TYPE = {
  TEST: 'TEST',
  BASIC: 'BASIC',
  NOTIFICATION: 'NOTIFICATION',
  MESSAGE: 'MESSAGE',
  BANNER: 'BANNER',
} as const;

type ObjectValues<T> = T[keyof T];

export type StickyAlertType = ObjectValues<typeof STICKY_ALERT_TYPE>;
